// graphql/mutations/seatingCharts.js
import { gql } from "@apollo/client";

export const CREATE_SEATING_CHART = gql`
  mutation CreateSeatingChart($input: CreateSeatingChartInput!) {
    createSeatingChart(input: $input) {
      id
      name
      mode
      status
    }
  }
`;

export const UPDATE_SEATING_CHART = gql`
  mutation UpdateSeatingChart($input: UpdateSeatingChartInput!) {
    updateSeatingChart(input: $input) {
      id
      name
      canvasElements
      canvasWidth
      canvasHeight
    }
  }
`;

export const PUBLISH_SEATING_CHART = gql`
  mutation PublishSeatingChart($id: ID!) {
    publishSeatingChart(id: $id) {
      id
      status
      version
      publishedAt
    }
  }
`;

export const DELETE_SEATING_CHART = gql`
  mutation DeleteSeatingChart($id: ID!) {
    deleteSeatingChart(id: $id)
  }
`;

export const UPSERT_SEATING_CHART_SECTION = gql`
  mutation UpsertSeatingChartSection($input: UpsertSeatingChartSectionInput!) {
    upsertSeatingChartSection(input: $input) {
      id
      name
      x
      y
      width
      height
      rotation
      orderIndex
    }
  }
`;

export const UPDATE_SEATING_CHART_SECTION_CANVAS = gql`
  mutation UpdateSeatingChartSectionCanvas($input: UpdateSeatingChartSectionCanvasInput!) {
    updateSeatingChartSectionCanvas(input: $input) {
      id
      canvasElements
      canvasWidth
      canvasHeight
    }
  }
`;

export const DELETE_SEATING_CHART_SECTION = gql`
  mutation DeleteSeatingChartSection($id: ID!) {
    deleteSeatingChartSection(id: $id)
  }
`;

export const UPSERT_SEATING_CHART_CATEGORY = gql`
  mutation UpsertSeatingChartCategory($input: UpsertSeatingChartCategoryInput!) {
    upsertSeatingChartCategory(input: $input) {
      id
      chartId
      name
      color
      orderIndex
      seatCount
    }
  }
`;

export const DELETE_SEATING_CHART_CATEGORY = gql`
  mutation DeleteSeatingChartCategory($id: ID!) {
    deleteSeatingChartCategory(id: $id)
  }
`;

export const CREATE_SEATING_CHART_SEATS = gql`
  mutation CreateSeatingChartSeats($input: CreateSeatingChartSeatsInput!) {
    createSeatingChartSeats(input: $input) {
      id
      sectionId
      categoryId
      rowLabel
      label
      x
      y
      rotation
      metadata
    }
  }
`;

export const UPDATE_SEATING_CHART_SEATS = gql`
  mutation UpdateSeatingChartSeats($chartId: ID!, $seats: [SeatingChartSeatInput!]!) {
    updateSeatingChartSeats(chartId: $chartId, seats: $seats) {
      id
      sectionId
      categoryId
      rowLabel
      label
      x
      y
      rotation
      metadata
    }
  }
`;

export const DELETE_SEATING_CHART_SEATS = gql`
  mutation DeleteSeatingChartSeats($chartId: ID!, $ids: [ID!]!) {
    deleteSeatingChartSeats(chartId: $chartId, ids: $ids)
  }
`;

// --- chart events ---------------------------------------------------------

export const CREATE_CHART_EVENT = gql`
  mutation CreateChartEvent($input: CreateChartEventInput!) {
    createChartEvent(input: $input) {
      id
      name
      chartId
      eventId
      eventSessionId
      eventName
    }
  }
`;

export const UPDATE_CHART_EVENT = gql`
  mutation UpdateChartEvent($input: UpdateChartEventInput!) {
    updateChartEvent(input: $input) {
      id
      description
      holdTtlMinutes
    }
  }
`;

export const DELETE_CHART_EVENT = gql`
  mutation DeleteChartEvent($id: ID!) {
    deleteChartEvent(id: $id)
  }
`;

export const LINK_TICKET_TYPE_SEATING_CATEGORIES = gql`
  mutation LinkTicketTypeSeatingCategories($input: LinkTicketTypeSeatingCategoriesInput!) {
    linkTicketTypeSeatingCategories(input: $input) {
      id
      seatingChartCategories {
        id
        name
        color
      }
    }
  }
`;

export const HOLD_CHART_EVENT_SEATS = gql`
  mutation HoldChartEventSeats($input: HoldChartEventSeatsInput!) {
    holdChartEventSeats(input: $input) {
      seatId
      holdToken
      holdExpiresAt
      status
    }
  }
`;

export const RELEASE_CHART_EVENT_SEATS = gql`
  mutation ReleaseChartEventSeats($input: ReleaseChartEventSeatsInput!) {
    releaseChartEventSeats(input: $input) {
      seatId
      status
    }
  }
`;

export const APPLY_CHART_EVENT_SEAT_CHANGES = gql`
  mutation ApplyChartEventSeatChanges($input: ApplyChartEventSeatChangesInput!) {
    applyChartEventSeatChanges(input: $input) {
      seatId
      status
    }
  }
`;